import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="conversations-filter"
export default class extends Controller {
  static targets = ["form"];

  filterChanged() {
    this.formTarget.requestSubmit();
  }
}
